import { Gamecloud } from '../../gamecloud';
import { createPermissionInstances, PermissionsUI } from './permissionsUI';
import { Notification } from '../../../notification/notfication';
import Axios from 'axios';
import i18next from 'i18next';

class Permissions extends Gamecloud {
  private server_id: any;

  public constructor(private ui: PermissionsUI) {
    super();
    this.loader.enable();

    const url = window.location + '';
    const urlArr = url.split('/');
    this.server_id = urlArr[(urlArr.length-2)];

    this.fetch();
    this.ui.onFormSubmit(this.addUser.bind(this));
  }

  private fetch() {
    Axios.post(window.ajaxPath + '/loadTable/' + this.server_id, {}, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response) => {
      this.loader.disable();
      this.ui.render(response.data);
      this.ui.onDeleteButtonClick(this.removeUser.bind(this));
    });
  }

  private removeUser(id: number) {
    this.loader.enable();
    Axios.post(window.ajaxPath + '/removeUser/' + this.server_id + '/' + id, {}, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response) => {
      this.loader.disable();
      new Notification('success', 'Done.', response.data.message);
      this.fetch();
    }).catch((response) => {
      this.loader.disable();
      new Notification('danger', 'Oops.', response.data.message);
    });
  }

  private addUser() {
    if (this.ui.getUsername().toString().length === 0) {
      new Notification('danger',
          i18next.t('general:non_special_texts.something_is_wrong'),
          i18next.t('gameserver:permissions.required_username')
      );
      return;
    }
    this.loader.enable();
    Axios.post(window.ajaxPath + '/addUser/' + this.server_id + '/' + this.ui.getUsername(), {}, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response) => {
      this.loader.disable();
      new Notification('success', 'Done.', response.data.message);
      this.fetch();
    }).catch((error) => {
      this.loader.disable();
      new Notification(
          'danger',
          i18next.t('general:non_special_texts.something_is_wrong'),
          error.response.data.message
      );
    });

    this.ui.clearInput();
  }
}

export function initPermissions() {
  return createPermissionInstances().map((ui: PermissionsUI) => {
    return new Permissions(ui);
  })
}
